<template>
  <div class="food-card-component" :class="{'with-stop': item.hasStop }">
    <div
      class="card-image d-flex align-center justify-center"
      @click="openFoodWindow"
    >
      <img v-if="item.image" :src="item.image" alt="Food" />
      <font-awesome-icon v-if="!item.image" icon="utensils" />

      <div v-if="item.hasStop" class="food-card_stop">
        На стопе
      </div>
    </div>
    <div class="badge-left d-flex flex-column align-center">
      <component :is="getLeftSticker" />
      <icon-doubling v-if="isDoubling" />
      <!--      <div class="d-flex flex-column align-center fox-coins" v-if="hasBonus">
        <icon-bonus />
        <span>+{{ item.foxCoinsAdd }}</span>
      </div>-->
    </div>

    <div class="badge-right d-flex flex-column align-center">
      <component :is="getRightSticker" />
    </div>

    <div class="footer" @click="addItem">
      <div class="d-flex align-center justify-space-between">
        <div class="card-info">
          <span class="title font-weight-regular">{{ item.name }}</span>
          <span class="price font-weight-medium">{{ item.price | amountStringWithCurrency }}</span>
        </div>
        <v-btn
          :disabled="item.hasStop"
          class="button-plus"
          color="#FF9500"
          dark
          circle
          fab
          depressed
        >
          <font-awesome-icon icon="plus" />
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import mixinGetFoodStickers from '@/mixins/get-food-stickers'
  import mixinSnackbarMessage from '@/mixins/snackbar-message'
  import IconDoubling from '@/components/order-processing/order-components/icons/IconDoubling'
  import orderEdit from '@/mixins/order-edit'

  export default {
    name: 'FoodCard',
    components: { IconDoubling },
    mixins: [mixinGetFoodStickers, mixinSnackbarMessage, orderEdit],
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      ...mapState({
        basket: (state) => state.baskets.basket,
      }),
      ...mapGetters({
        isNewOrderPage: 'app/isNewOrderPage',
      }),
      getItemPrice () { return this.item.price ? this.item.price + ' ₽' : '0 ₽' },
      hasBonus () { return this.item.foxCoinsAdd },
      isDoubling () { return this.item && this.item.isDoubling },
    },
    methods: {
      openFoodWindow () {
        // this.$store.commit(this.orderEditPrefix + '/setFoodWindowState', true)
        this.$emit('openFoodWindow', this.item)
      },
      addItem () {
        const payload = {
          menuItemId: this.item.id,
        }
        this.$store
          .dispatch('baskets/addBasketItem', {
            data: payload,
            id: this.basket.id,
          })
          .then((res) => {
            if (res.status === 200) {
              this.$store.commit('baskets/setBasket', res.data.data)
            } else {
              this.showErrorMessage(res.response.data.message)
            }
          })
      },
    },
  }
</script>

<style lang="less" scoped>
.food-card-component {
  position: relative;
  background-color: #ffffff;
  border-radius: 30px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  //padding-top: 10px;
  z-index: 0;
  font-size: 12px;

  .media-xl({
    font-size: 14px;
  });

  .badge-left {
    position: absolute;
    top: 15px;
    left: 8px;
    svg {
      margin-bottom: 10px;
    }

    .fox-coins {
      svg {
        margin-bottom: 0;
      }
      span {
        color: #ff9100;
        font-size: 1em;
        font-weight: bold;
      }
    }
  }

  .badge-right {
    position: absolute;
    top: 15px;
    right: 26px;
    svg {
      margin-bottom: 10px;
    }
  }

  .card-image {
    width: 100%;
    height: 182px;
    text-align: center;
    cursor: pointer;
    object-fit: contain;
    background-color: @menu-item-image-bg;

    svg {
      width: 70px;
      height: 70px;
      opacity: 0.4;
      .fill-svg(@color-primary);
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .footer {
    padding: 11px 20px 15px 16px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #ffddac;
    }
    .card-info {
      .title,
      .price {
        display: block;
      }

      .title {
        font-size: 1em !important;
        font-weight: 500 !important;
        line-height: 1;
        margin-bottom: 6px;
        min-height: 2em;
      }

      .price {
        font-size: 1.5em;
        line-height: 1.2;
      }
    }

    .button-plus {
      margin-left: 28px;
      width: 40px;
      height: 40px;

      svg {
        width: 20px;
        height: 20px;
      }

    }
  }

  // До 1400px в списке меню подписи карточки крупнее: исходные 12px на
  // терминале 1024px и узких мониторах не читаются. Чтобы название 17px
  // помещалось, оно идёт на всю ширину карточки, а цена и кнопка добавления
  // стоят под ним в одной строке
  @media (max-width: 1400px) {
    .menu-items-list & {
      display: flex;
      flex-direction: column;
      height: 100%;

      .card-image {
        flex: 0 0 auto;
      }

      .footer {
        position: relative;
        display: flex;
        flex: 1 1 auto;
        padding: 11px 16px 14px;

        & > .d-flex {
          flex: 1 1 auto;
          min-width: 0;
          align-items: stretch !important;
        }

        .card-info {
          display: flex;
          flex: 1 1 auto;
          flex-direction: column;
          min-width: 0;

          // Обычно одна-две строки; место под две держим всегда, чтобы цены
          // в ряду стояли на одной линии. Третья - для редких длинных названий:
          // обрезать их нельзя, различие бывает в последнем слове («подарок»)
          .title {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            font-size: 17px !important;
            line-height: 1.18;
            min-height: 2.36em;
            margin-bottom: 0;
            letter-spacing: 0 !important;
          }

          // !important - у класса font-weight-medium от Vuetify вес с !important
          .price {
            margin-top: auto;
            padding: 10px 50px 10px 0;
            font-size: 19px;
            line-height: 22px;
            font-weight: 300 !important;
            white-space: nowrap;
          }
        }

        // кнопка стоит в строке цены и не отнимает ширину у названия
        .button-plus {
          position: absolute;
          right: 14px;
          bottom: 14px;
          width: 42px;
          height: 42px;
          margin-left: 0;

          svg {
            width: 18px;
            height: 18px;
          }
        }
      }
    }
  }

  // Уже 1200px карточка ещё и плотнее: ниже картинка, меньше скругление,
  // поля и стикеры (зазор между карточками задаёт MenuItemsList)
  @media (max-width: 1199px) {
    .menu-items-list & {
      border-radius: 16px;
      box-shadow: 0 1px 2px rgba(20, 30, 50, 0.06), 0 6px 18px rgba(20, 30, 50, 0.07);

      .card-image {
        height: 104px;
        padding: 6px 10px 0;

        svg {
          width: 44px;
          height: 44px;
        }
      }

      // стикеры рассчитаны на большую карточку - уменьшаем вместе с ней
      .badge-left {
        top: 7px;
        left: 7px;
        transform: scale(0.62);
        transform-origin: top left;
      }

      .badge-right {
        top: 7px;
        right: 7px;
        transform: scale(0.7);
        transform-origin: top right;
      }

      .footer {
        padding: 9px 12px 10px;

        .button-plus {
          right: 10px;
          bottom: 10px;
        }
      }
    }
  }

  &.with-stop {
    .card-image {
      position: relative;

      img {
        opacity: 0.5;
        filter: blur(1px);
      }
      .food-card_stop {
        display: flex;
        align-items: center;
        padding: 10px;
        border-radius: 10px;
        position: absolute;
        top: 50%;
        left: 50%;
        background: #ff005f;
        color: #fff;
        font-size: 14px;
        text-transform: uppercase;
        font-weight: bold;
        white-space: nowrap;
        transform: translate(-50%, -50%);
        svg {
          width: 30px;
          height: 30px;
          margin-right: 10px;
          color: #fff;
          path {
            fill: #ffffff !important;
          }
        }
      }
    }

  }
}
</style>
